<template>
  <div class="cost-type-list-container">
    <el-card class="page-header-card" shadow="hover">
      <div class="page-header">
        <div class="page-title-section">
          <h2 class="page-title">
            <font-awesome-icon icon="tags" class="page-title-icon" />
            Зардлын төрөл удирдах хэсэг
          </h2>
          <p class="page-subtitle">Зардлын төрлийг үүсгэх, засах, устгах</p>
        </div>
        <el-button
          v-if="checkPermissionsPage('admin')"
          @click="createCostTypeDialogOpen()"
          type="primary"
          size="large"
          class="create-button"
        >
          <font-awesome-icon icon="plus" class="button-icon" />
          Шинэ төрөл үүсгэх
        </el-button>
      </div>
    </el-card>

    <el-card class="table-card mt-10" shadow="hover">
      <template #header>
        <div class="table-header">
          <font-awesome-icon icon="list" class="table-header-icon" />
          <span class="table-header-title">Зардлын төрлийн жагсаалт</span>
          <el-tag type="info" class="table-count-tag">{{ data.length }} төрөл</el-tag>
        </div>
      </template>
      <el-table :data="data" style="width: 100%" border class="modern-cost-type-table" stripe>
            <el-table-column label="Нэр" prop="name"></el-table-column>
            <el-table-column label="Тайлбар" prop="description"></el-table-column>
            <el-table-column label="Үүсгэсэн огноо" prop="createdAt" width="180">
              <template #default="scope">
                {{ formatDate(scope.row.createdAt) }}
              </template>
            </el-table-column>

            <!-- Actions Column -->
            <el-table-column v-if="checkPermissionsPage('admin')" label="Үйлдэл" width="250" align="center">
              <template v-slot="scope">
                <el-button-group>
                  <el-button
                    v-if="checkPermissionsPage('admin')"
                    @click="createCostTypeDialogOpen(scope.row)"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="edit" class="button-icon-small" />
                    Засварлах
                  </el-button>
                  <el-button
                    v-if="checkPermissionsPage('admin')"
                    @click="deleteRow(scope.row)"
                    type="danger"
                    size="small"
                    class="action-button"
                  >
                    <font-awesome-icon icon="trash" class="button-icon-small" />
                    Устгах
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <!-- Pagination -->
          <el-pagination
            @current-change="handlePageChange"
            :current-page="currentPage"
            :page-size="pageSize"
            :total="data.length"
            layout="total, prev, pager, next, jumper"
            class="modern-pagination" />
    </el-card>
    <CreateCostTypeDialog :selectedCostType="this.targetCostType" @refresh="loadData" />
  </div>
</template>
<script>
import services from '@/services'
import { ElMessage, ElMessageBox } from 'element-plus'
import { checkPermissions } from '@/helpers/custom'
import CreateCostTypeDialog from './createCostTypeDialog.vue'
import dayjs from 'dayjs'

export default {
  name: 'CostTypeListPage',
  components: {
    CreateCostTypeDialog
  },
  created () {
    this.loadData()
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      data: [],
      targetCostType: {}
    }
  },
  methods: {
    async loadData () {
      try {
        const response = await services.get('costTypes')
        if (response && response.type === 'success') {
          this.data = response.data || []
          this.totalRecords = response.data?.length || 0
        } else if (response && response.data) {
          this.data = response.data || []
          this.totalRecords = response.data?.length || 0
        } else {
          ElMessage.error('Өгөгдөл олдсонгүй!')
        }
      } catch (error) {
        console.error('Error fetching data: ', error)
        ElMessage.error(`Өгөгдөл ачаалахад алдаа гарлаа: ${error.message}`)
      }
    },
    checkPermissionsPage (data) {
      return checkPermissions(data)
    },
    handlePageChange (page) {
      this.currentPage = page
    },
    createCostTypeDialogOpen (data) {
      this.targetCostType = data || {}
      this.$store.dispatch('setCreateCostTypeDialog', true)
    },
    async deleteRow (row) {
      try {
        await ElMessageBox.confirm('Та энэ зардлын төрлийг устгахдаа итгэлтэй байна уу?', 'Баталгаажуулалт', {
          confirmButtonText: 'Тийм',
          cancelButtonText: 'Үгүй',
          type: 'warning'
        })
        await services.delete('costTypes', row.id)
        this.loadData()
        ElMessage.success('Амжилттай устгагдлаа!')
        const index = this.data.indexOf(row)
        if (index > -1) {
          this.data.splice(index, 1)
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('Устгахад алдаа гарлаа!')
        }
      }
    },
    formatDate (date) {
      if (!date) return '-'
      return dayjs(date).format('YYYY-MM-DD HH:mm')
    }
  }
}
</script>

<style lang="scss" scoped>
/* Cost Type List Container */
.cost-type-list-container {
  padding: 0;
}

/* Page Header Card */
.page-header-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
  margin-bottom: 24px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.page-title-section {
  flex: 1;
}

.page-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin: 0 0 8px 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title-icon {
  color: #667eea;
  font-size: 32px;
}

.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}

.create-button {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  transition: all 0.3s ease;
}

.create-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.button-icon {
  margin-right: 8px;
}

/* Table Card */
.table-card {
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
}

.table-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-header-icon {
  color: #667eea;
  font-size: 20px;
}

.table-header-title {
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
  flex: 1;
}

.table-count-tag {
  border-radius: 20px;
  padding: 4px 12px;
}

/* Modern Cost Type Table */
.modern-cost-type-table {
  border-radius: 8px;
  overflow: hidden;
}

.modern-cost-type-table :deep(.el-table__header) {
  background: #f9fafb;
}

.modern-cost-type-table :deep(.el-table__header th) {
  background: #f9fafb;
  color: #374151;
  font-weight: 600;
  border-bottom: 2px solid #e5e7eb;
  padding: 16px 0;
}

.modern-cost-type-table :deep(.el-table__body tr:hover) {
  background: #f3f4f6;
}

.modern-cost-type-table :deep(.el-table__body td) {
  padding: 16px 0;
}

/* Action Buttons */
.action-button {
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-button:hover {
  transform: translateY(-1px);
}

.button-icon-small {
  margin-right: 4px;
  font-size: 12px;
}

/* Pagination */
.modern-pagination {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

/* Responsive */
@media (max-width: 768px) {
  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .page-title {
    font-size: 24px;
  }

  .action-button {
    margin-bottom: 4px;
    font-size: 11px;
    padding: 6px 8px;
  }

  .button-icon-small {
    display: none;
  }

  /* Mobile Table Scroll */
  .table-card {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .modern-cost-type-table {
    min-width: 600px;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .create-button {
    width: 100%;
    margin-top: 8px;
  }
}
</style>
